import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsMembershipOverthrowModel } from './types';
import legalAssociationsMembershipOverthrowItemValidator from './validators/item';

const legalAssociationsMembershipOverthrowValidator: ValidateJSModel<LegalAssociationsMembershipOverthrowModel> = {
  HasOverthrow: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasOverthrow?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsMembershipOverthrowItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsMembershipOverthrowValidator;
